import { sanitizedFilename } from '../../utils/utils.js';
import * as types from '../ActionTypes/actionTypes.js'
import { CALL_API } from '../middleware/api'

export function uploadDocuments (document, uploadPathFolder) {
  let formData = new FormData();
  let apiPath = 'applicationresources/';
  let pathUpload = 'uploadsingle';

  if (uploadPathFolder) {
    apiPath = apiPath + uploadPathFolder
  } else {
    apiPath = apiPath + pathUpload
  }
  formData.append('saveby', document.originalname);
  formData.append('file', document);
  const options = {
    headers: {
      processData: 'false',
      contentType: 'false',
      dataType: 'json',
      Accept: '*/*',
    },
    method: 'POST',
    body: formData
  };
  return {
    [CALL_API]: {
      endpoint: apiPath,
      authenticated: true,
      types: [types.DOCUMENT_UPLOAD_REQUEST, types.DOCUMENT_UPLOAD_SUCCESS, types.DOCUMENT_UPLOAD_FAILURE],
      config: options
    }
  }
}

export function loadAllDocuments (pathImgs) {
  const options = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, method: 'GET' };
  let pathFinal = 'applicationresources/';
  if (pathImgs) {
    pathFinal = pathFinal + pathImgs
  }

  return {
    [CALL_API]: {
      endpoint: pathFinal,
      authenticated: true,
      types: [types.DOCUMENTS_LOAD_REQUEST, types.DOCUMENTS_LOAD_SUCCESS, types.DOCUMENTS_LOAD_FAILURE],
      config: options
    }
  }
}

export function downloadFileFromServer (filepath) {
  let [, ...remaining] = filepath.split('_');
  const options = { headers: { 
    'Content-disposition': 'attachment; filename=' + remaining.join('_') ,
    'Content-Type': 'application/octet-stream'
  }, method: 'GET' };
  
  return {
    [CALL_API]: {
      endpoint: `applicationresources/assetEquipmentData/${sanitizedFilename(filepath)}`,
      authenticated: true,
      types: [types.FILE_DOWNLOAD_REQUEST, types.FILE_DOWNLOAD_SUCCESS, types.FILE_DOWNLOAD_FAILURE],
      config: options
    }
  }
}


// WEBPACK FOOTER //
// ./src/reduxRelated/actions/documentUpload.js